import { Fragment, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Mounts its page afresh for every link opened into it.
 *
 * An email link opened while the app already shows that route only changes
 * the params: React Router keeps the same component instance, so per-link
 * state from the first link (a `started` guard, an error, a confirm screen,
 * a form prefilled from the query, a request still in flight) carried over
 * to the second. A second RSVP link was never sent (backlog c-083).
 *
 * Keyed on the navigation, not the URL: the SAME link tapped again after a
 * failure (a network error, then a retry) is a new navigation with the same
 * path and query, and it must try again too (c-092). The first page's late
 * reply then lands in an unmounted component.
 */
export function OnePerLink({ children }: { children: ReactNode }) {
  const { key } = useLocation();
  return <Fragment key={key}>{children}</Fragment>;
}
